//noinspection SpellCheckingInspection
// This function is for GPs, not for pharmacists
// Pharmacist AHPRA numbers look like PHA0001234567 - there is no check digit
// Other three letter prefixes are used for other medical professions

//var PROVIDER_NUMBER_REGEXP = /^[0-9]{6}[0-9abcdefghjklmnpqrtuvwxyABCDEFGHJKLMNPQRTUVWXY]{1}[abfhjkltwxyABFHJKLTWXY]{1}$/;

function providerNumber() {
    return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
            ctrl.$validators.providerNumber = function(modelValue, viewValue) {

                if (ctrl.$isEmpty(modelValue)) {
                    // consider empty models to be valid
                    return true;
                }
                //For debug only remove
                return true;

                //if (PROVIDER_NUMBER_REGEXP.test(viewValue)) {
                //    // Check as well the check character at the end
                //    var locationChar = viewValue.charAt(6).toUpperCase();
                //    var plvTable = {
                //        '0': '0',
                //        '1': '1',
                //        '2': '2',
                //        '3': '3',
                //        '4': '4',
                //        '5': '5',
                //        '6': '6',
                //        '7': '7',
                //        '8': '8',
                //        '9': '9',
                //        'A': '10',
                //        'B': '11',
                //        'C': '12',
                //        'D': '13',
                //        'E': '14',
                //        'F': '15',
                //        'G': '16',
                //        'H': '17',
                //        'J': '18',
                //        'K': '19',
                //        'L': '20',
                //        'M': '21',
                //        'N': '22',
                //        'P': '23',
                //        'Q': '24',
                //        'R': '25',
                //        'T': '26',
                //        'U': '27',
                //        'V': '28',
                //        'W': '29',
                //        'X': '30',
                //        'Y': '31'
                //    };
                //    var plv = plvTable[locationChar];
                //    var remainder = ((Number(viewValue.charAt(0)) * 3) +
                //        (Number(viewValue.charAt(1)) * 5) +
                //        (Number(viewValue.charAt(2)) * 8) +
                //        (Number(viewValue.charAt(3)) * 4) +
                //        (Number(viewValue.charAt(4)) * 2) +
                //        Number(viewValue.charAt(5)) +
                //        plv * 6) % 11;
                //    var remainderCheckTable = {
                //        0:  'Y',
                //        1:  'X',
                //        2:  'W',
                //        3:  'T',
                //        4:  'L',
                //        5:  'K',
                //        6:  'J',
                //        7:  'H',
                //        8:  'F',
                //        9:  'B',
                //        10: 'A'
                //    };
                //    var checkChar = viewValue.charAt(7).toUpperCase();
                //    // This test proves whether it's valid
                //    return (remainderCheckTable[remainder] == checkChar);
                //}
                //
                //// It's invalid
                //return false;
            };
        }
    };
}

export default angular.module('providerNumber', []).directive('providerNumber', providerNumber).name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/directives/providerNumber.directive.js
 **/